import { Container } from "semantic-ui-react"
import { DtsManagerList } from "../../../../Components/secure/dtsManager/DtsManagerList"

export const DtsManagers = () => {
  return (
    <Container>
      <DtsManagerList />
    </Container>
  )
}